// TODO: ant form 待更新 v4

import { forwardRef, useState, useEffect, useRef } from 'react';
import { Prompt, useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Input, Select, Mentions, message } from 'antd';
import { Center, Heading, useToast } from '@chakra-ui/react';
import i18next from 'i18next';
import cx from 'classnames';
import { useTranslation, Trans } from 'react-i18next';

import localeTw from 'antd/lib/locale/zh_TW';
import localeEn from 'antd/lib/locale/en_US';

import { ApiMessagesConstants } from '@Constants/apiMessagesConstants';
import { API_RETURN_CODE } from '@Constants/apiReturnCode';

import { useClearAllStates } from '@Hooks/useClearAllStates';

import { RenderedToast } from '@Components/toast';

import { parseBlobData, errorNotification } from './commonFunction';
import { POINTS_CANNOT_BE_NEGATIVE_403 } from './commonParameters';

import AntdErrorAlert from '../components/antdErrorAlert';

import * as actions from '../actions';
import { store } from '../store';

import styles from './commonHooks.scss';

export function inputFormItem(
  id,
  label,
  required,
  initialValue,
  type,
  formContent,
  className = '',
  placeholder = '',
  maxLength = 255,
  name = '',
  disabled = false,
) {
  if (type === 'email') {
    return (
      <Form.Item label={label} labelAlign="left">
        {formContent.getFieldDecorator(id, {
          rules: [
            {
              type: 'email',
              message: `${i18next.t('common.typeValidEmail')}`,
            },
            {
              required,
              message: `${i18next.t('common.pleaseType')} ${name}`,
            },
            {
              validator: (rule, value, callback) => {
                if (value?.length > maxLength) {
                  callback(`${i18next.t('common.isExceedMaximumLength')}（${maxLength}）`);
                }

                callback();
              },
            },
          ],
          initialValue,
        })(
          <Input
            className={cx(styles['form-item__input'], styles[className])}
            type={type}
            autoComplete="off"
            placeholder={placeholder}
            maxLength={maxLength}
            disabled={disabled}
          />,
        )}
      </Form.Item>
    );
  }
  return (
    <Form.Item label={label} labelAlign="left">
      {formContent.getFieldDecorator(id, {
        rules: [
          {
            required,
            message: `${i18next.t('common.pleaseType')} ${name}`,
          },
          {
            validator: (rule, value, callback) => {
              if (value?.length > maxLength) {
                callback(`${i18next.t('common.isExceedMaximumLength')}（${maxLength}）`);
              }

              callback();
            },
          },
        ],
        initialValue,
      })(
        <Input
          className={cx(styles['form-item__input'], styles[className])}
          type={type}
          autoComplete="off"
          placeholder={placeholder}
          maxLength={maxLength}
          disabled={disabled}
        />,
      )}
    </Form.Item>
  );
}

export function tagFormItem(id, label, formContent, initialValue = [], maxTagTextLength = 1024) {
  return (
    <Form.Item label={label} labelAlign="left">
      {formContent.getFieldDecorator(id, {
        rules: [
          {
            required: false,
            type: 'array',
            validator: (rule, value, callback) => {
              let length = 0;

              value.forEach((element) => {
                length += element.length;
              });

              if (length > maxTagTextLength) {
                callback(`${i18next.t('common.isExceedMaximumLength')}（${maxTagTextLength}）`);
              }

              callback();
            },
          },
        ],
        initialValue,
      })(
        <Select mode="tags" className={styles['form-item__input']}>
          {initialValue?.map((tag) => {
            return <Select.Option key={tag}>{tag}</Select.Option>;
          })}
        </Select>,
      )}
    </Form.Item>
  );
}

export function mentionsFormItem(
  id,
  label,
  required,
  formContent,
  initialValue = '',
  rows = null,
  optionInitialValue = [],
  placeholder,
  maxLength = 1024,
  name = '',
  getValueFromEvent,
) {
  const { Option } = Mentions;

  return (
    <Form.Item label={label} labelAlign="left">
      {formContent.getFieldDecorator(id, {
        // trigger: 'onBlur',
        // valuePropName: 'defaultValue',
        initialValue,
        getValueFromEvent,
        rules: [
          {
            required,
            validator: (rule, value, callback) => {
              if (value.length > maxLength) {
                callback(`${i18next.t('common.isExceedMaximumLength')}（${maxLength}）`);
              }

              if (value.length === 0) {
                callback(`${i18next.t('common.pleaseType')} ${name}`);
              }

              callback();
            },
          },
        ],
      })(
        <Mentions rows={rows} prefix="{{" placeholder={placeholder}>
          {Object.keys(optionInitialValue).length > 0 &&
            Object.values(optionInitialValue).map((option) => {
              return (
                <Option value={option.value} key={option.value}>
                  {option.name}
                </Option>
              );
            })}
        </Mentions>,
      )}
    </Form.Item>
  );
}

export const TextAreaFormItem = forwardRef((props, ref) => {
  const { id, label, required, placeholder, onChange, initialValue, formContent } = props;
  const { t } = useTranslation();
  const textareaRef = ref.current;
  function autoAdjustHeight() {
    textareaRef.style.height = 'auto';
    textareaRef.style.height = `${textareaRef.scrollHeight}px`;
  }
  return (
    <Form.Item label={label} labelAlign="left">
      {formContent.getFieldDecorator(id, {
        rules: [
          {
            required,
            message: `${t('common.pleaseType')} ${label}`,
          },
        ],
        initialValue,
      })(
        <textarea
          className={styles['form-item__textarea']}
          onChange={onChange}
          placeholder={placeholder}
          spellCheck="false"
          ref={ref}
          onKeyDown={() => window.setTimeout(autoAdjustHeight, 0)}
        />,
      )}
    </Form.Item>
  );
});

// call API 異常時的 Alert message
export const useServerFailedAlert = (onCloseStatement = null) => {
  const [isServerFailed, setIsServerFailed] = useState(false);
  const [serverErrorAlert, setServerErrorAlert] = useState(null);

  useEffect(() => {
    return () => {
      setIsServerFailed(false);
      setServerErrorAlert(null);
    };
  }, []);

  useEffect(() => {
    if (isServerFailed) {
      setServerErrorAlert(
        <AntdErrorAlert
          onCloseFunction={() => {
            setIsServerFailed(false);
            if (onCloseStatement) onCloseStatement();
          }}
        />,
      );
    } else {
      setServerErrorAlert(null);
    }
  }, [isServerFailed]);

  return [setIsServerFailed, serverErrorAlert];
};

// TODO: 待所有 API request/response 替換成 react-query 的寫法，就移除
export const useAPIResponseStatementEXP = (
  apiIsLoading,
  apiMessage,
  apiFailed,
  statements = () => {
    return {
      200: () => {},
      204: () => {},
      400: () => {},
      401: () => {},
      403: () => {},
      404: () => {},
      500: () => {},
      commonStatement: () => {},
      errorStatement: () => {},
    };
  },
  pass = true,
) => {
  const { t } = useTranslation();
  const toast = useToast();
  const history = useHistory();
  const dispatch = useDispatch();

  const [setIsServerFailed, serverErrorAlert] = useServerFailedAlert();
  const { clearAllStates } = useClearAllStates();

  function getErrorToast(id, title, duration = 10 * 1000) {
    return toast({
      id,
      status: 'error',
      position: 'top',
      duration,
      isClosable: true,
      render: ({ id, onClose }) => (
        <RenderedToast id={id} onClose={onClose} status="error" title={title} />
      ),
    });
  }

  function handle403ErrorMessage(data) {
    if (data?.msg === ApiMessagesConstants.UNAUTHORIZED) {
      dispatch(actions.getProfileAction.getProfile());

      return;
    }

    if (data?.msg === POINTS_CANNOT_BE_NEGATIVE_403) {
      message.error({
        content: t('common.pointsCannotBeNegative403ErrorMessage'),
      });
    }

    if (data?.msg === ApiMessagesConstants.PLAN_EXPIRED) {
      dispatch(actions.getProfileAction.getProfile());

      if (!toast.isActive(ApiMessagesConstants.PLAN_EXPIRED)) {
        getErrorToast(ApiMessagesConstants.PLAN_EXPIRED, t('common.expirationMessage'), 100 * 1000);
      }
    }
  }

  function handle404ErrorMessage(data) {
    if (data?.msg === ApiMessagesConstants.PROJECT_NOT_FOUND) {
      if (!toast.isActive(ApiMessagesConstants.PROJECT_NOT_FOUND)) {
        getErrorToast(ApiMessagesConstants.PROJECT_NOT_FOUND, t('common.eventNotFound'));
      }

      history.push('/');

      return;
    }

    if (data?.msg === ApiMessagesConstants.ADMIN_NOT_FOUND) {
      if (!toast.isActive(ApiMessagesConstants.ADMIN_NOT_FOUND)) {
        getErrorToast(ApiMessagesConstants.ADMIN_NOT_FOUND, t('common.adminNotFoun'));
      }

      dispatch(actions.logout());
    }
  }

  useEffect(() => {
    if (
      !apiIsLoading &&
      apiMessage !== '' &&
      (apiFailed === '' || apiFailed === null || apiFailed === false) &&
      apiMessage?.status >= 200 &&
      apiMessage.status < 300 &&
      apiMessage?.data &&
      pass
    ) {
      // 維護中
      if (apiMessage?.data?.returnCode === API_RETURN_CODE.module.maintenance) {
        toast({
          title: t('common.maintenance'),
          status: 'warning',
          duration: 5000,
          position: 'top',
        });

        history.push('/maintenance');
        return;
      }

      if (apiMessage?.data?.returnCode === 1) {
        if (
          apiMessage?.data?.msg === 'Event not found' ||
          apiMessage?.data?.msg === ApiMessagesConstants.PROJECT_NOT_FOUND
        ) {
          toast({
            title: t('common.eventNotFound'),
            status: 'error',
            duration: 5000,
            position: 'top',
          });

          history.push('/home');

          return;
        }
      }

      const { systemTimestamp } = apiMessage?.data;

      if (systemTimestamp) {
        dispatch(actions.setSystemTimestamp(systemTimestamp || null));
      }

      statements()?.[200] && statements()[200]();
      statements()?.[204] && statements()[204]();
      statements().commonStatement && statements().commonStatement();
      setIsServerFailed(false);

      return;
    }

    if (apiMessage?.status === 400 && !apiIsLoading) {
      statements()?.[400] && statements()[400]();
      statements().commonStatement && statements().commonStatement();
      statements().errorStatement && statements().errorStatement();
      setIsServerFailed(false);
    }

    if (apiMessage?.status === 401 && !apiIsLoading) {
      clearAllStates();
      errorNotification();
      statements()?.[401] && statements()[401]();
      statements().commonStatement && statements().commonStatement();
      statements().errorStatement && statements().errorStatement();
      setIsServerFailed(false);
    }

    if (apiMessage?.status === 403 && !apiIsLoading) {
      statements()?.[403] && statements()[403]();
      statements()?.commonStatement && statements().commonStatement();
      statements()?.errorStatement && statements().errorStatement();
      setIsServerFailed(false);

      if (
        apiMessage?.data?.returnCode === API_RETURN_CODE.admin.tokenExpired ||
        apiMessage?.data?.returnCode === API_RETURN_CODE.module.notFound
      ) {
        clearAllStates();
        errorNotification();
        setIsServerFailed(false);
      }

      if (apiMessage?.config?.responseType === 'blob') {
        parseBlobData(apiMessage.data || [], (result) => {
          handle403ErrorMessage(result);
        });

        return;
      }

      handle403ErrorMessage(apiMessage.data);
    }

    if (apiMessage?.status === 404 && !apiIsLoading) {
      statements()?.[404] && statements()[404]();
      statements().commonStatement && statements().commonStatement();
      statements().errorStatement && statements().errorStatement();
      setIsServerFailed(false);

      handle404ErrorMessage(apiMessage.data);
    }

    if (apiFailed && !apiMessage && !apiIsLoading && setIsServerFailed !== '') {
      setIsServerFailed(true);
      statements()?.[500] && statements()[500]();
      statements().errorStatement && statements().errorStatement();
    }
  }, [apiMessage, apiFailed, apiIsLoading, setIsServerFailed]);

  return [serverErrorAlert];
};

// 取得使用者目前的語言代號與 antd date picker 語言包
export const useGetUserLanguage = () => {
  const [language, setLanguage] = useState('default');
  const [locale, setLocale] = useState('zh-TW');

  const userLanguage =
    JSON.parse(window.localStorage.getItem('persist:env'))?.userLanguage || '"default"';

  useEffect(() => {
    switch (userLanguage) {
      case '"default"': {
        const browserLanguage = window.navigator.language;
        if (browserLanguage === 'zh-TW' || browserLanguage === '"zh-TW"') {
          setLanguage('zh-TW');
        } else {
          setLanguage(browserLanguage);
        }
        break;
      }
      default:
        if (userLanguage === 'zh-TW' || userLanguage === '"zh-TW"') {
          setLanguage('zh-TW');
        } else {
          setLanguage(userLanguage);
        }
    }
  }, [userLanguage]);

  useEffect(() => {
    if (language === 'zh-TW') {
      setLocale(localeTw);
    } else {
      setLocale(localeEn);
    }
  }, [language]);

  return { language, locale };
};

// 檢查所有在 array 的值不等於 undefined 和 null，並設定 useState 的值
// 可能要改成可以設定很多 useState 的方式，也就是 setState 傳進來會是 array
export const checkVariablesAreNormalAndSetUseState = (variableArray, state, setState) => {
  let isNormal = false;
  if (variableArray?.length > 0) {
    isNormal = variableArray.every((variable) => {
      return variable !== undefined && variable !== null;
    });
  }
  if (isNormal) {
    setState(state);
  }
};

// TODO: 待優化
// 取得網址特定位置(keyword)的 token or id，去取得多筆項目中的單一項目的 CRUD API
// e.g.: 應用在 EmailEdit or SurveyFormEdit Component
export const usePathnameToken = (
  history,
  type = 'pathname',
  keyword = '',
  lastWord = '',
  initialValue,
) => {
  const [token, setToken] = useState(initialValue);

  useEffect(() => {
    if (history?.location?.pathname && type === 'pathname') {
      const { pathname } = history.location;
      const keyWordIndex = pathname.indexOf(keyword);
      const lastWordIndex = pathname.indexOf(lastWord);
      const slicedPathname =
        lastWord && lastWordIndex !== 0 && lastWordIndex !== -1
          ? pathname.slice(keyWordIndex, lastWordIndex)
          : pathname.slice(keyWordIndex + keyword.length);

      if (slicedPathname) {
        setToken(slicedPathname);
      }

      return;
    }

    if (history?.location?.search && type === 'search') {
      const { search } = history.location;

      const allKeyValuePair = search
        .slice(1)
        .split('&')
        .map((keyValueString) => keyValueString.split('='))
        .map((keyValueArray) => {
          return {
            key: keyValueArray[0],
            value: keyValueArray[1] || '',
          };
        });

      const setTokenDone = allKeyValuePair.some((pair) => {
        if (pair.key === keyword) {
          if (pair.value === 'true') {
            setToken(true);

            return true;
          }

          if (pair.value === 'false') {
            setToken(false);

            return true;
          }

          setToken(pair.value);

          return true;
        }
      });

      if (!setTokenDone) {
        setToken('');
      }

      return;
    }

    setToken('');
  }, [history, keyword, lastWord]);

  return [token, setToken];
};

export const useIsDevelopment = () => {
  const [isDevelopment, setIsDevelopment] = useState(false);

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      setIsDevelopment(true);
    } else if (process.env.NODE_ENV.includes('production')) {
      setIsDevelopment(false);
    }
    return () => {
      setIsDevelopment(false);
    };
  }, [process.env.NODE_ENV]);

  return isDevelopment;
};

// 表單/設定 尚未儲存的提示
export const useSaveNotYet = (message) => {
  const [isSavedNotYet, setIsSavedNotYet] = useState(false);
  const [prompt, setPrompt] = useState('');
  const isSaveNotYetRef = useRef(false);

  const { t } = useTranslation();

  useEffect(() => {
    window.addEventListener('beforeunload', (e) => {
      e.preventDefault();
      if (isSaveNotYetRef.current) {
        e.returnValue = '';
      }
    });

    return () => {
      setIsSavedNotYet(false);
      isSaveNotYetRef.current = false;
    };
  }, []);

  useEffect(() => {
    isSaveNotYetRef.current = isSavedNotYet;
    setPrompt(
      <Prompt
        when={isSavedNotYet}
        message={message || t('common.areYouSureToWantToLeaveNotSave')}
      />,
    );
  }, [isSavedNotYet]);

  return { setIsSavedNotYet, prompt, isSavedNotYet };
};

// 預設輸出的顏色格式為 hex rgba
export const useSettingColorPicker = (color = '#ffffff') => {
  const [currentColor, setCurrentColor] = useState(color);

  const handleChange = (color) => {
    let hexCode = color;
    let alpha = Math.round(255 * color.rgb.a).toString(16);

    if (alpha.length < 2) {
      alpha = `0${alpha}`;
    }

    if (color.hex === 'transparent') {
      hexCode = `#00000000`;
    } else {
      hexCode = `${color.hex}${alpha}`;
    }

    setCurrentColor(hexCode);
  };

  return [currentColor, setCurrentColor, handleChange];
};

// Before F5 or reloading, popping up alert window
export const useBeforeUnloadHint = (isSavedNotYet) => {
  const isSavedNotYetRef = useRef(false);

  useEffect(() => {
    return () => {
      isSavedNotYetRef.current = false;
    };
  }, []);

  useEffect(() => {
    isSavedNotYetRef.current = isSavedNotYet;
  }, [isSavedNotYet]);

  useEffect(() => {
    window.addEventListener('beforeunload', (e) => {
      e.preventDefault();
      if (isSavedNotYetRef.current) {
        e.returnValue = '';
      }
    });
  }, []);

  return isSavedNotYetRef;
};

// do action after creating email draft
export const useActionAfterCreatingEmailDraft = (history, eventKey) => {
  const [editedKey, setEditedKey] = useState(null);
  const [isSelectedTemplate, setIsSelectedTemplate] = useState(false);

  useEffect(() => {
    if (editedKey && isSelectedTemplate) {
      history.push(`/email/${eventKey}/edit/${editedKey}`);
      store.dispatch(actions.initializeStates());
    }

    if (editedKey && !isSelectedTemplate) {
      store.dispatch(actions.initializeStates());
    }
  }, [history, editedKey, eventKey, isSelectedTemplate]);

  return [setIsSelectedTemplate, setEditedKey];
};

export const usePagination = (initialPageSize = 15, initialPresentPage = 1) => {
  const [presentPage, setPresentPage] = useState(initialPresentPage);
  const [pageSize, setPageSize] = useState(initialPageSize);

  function getPresentPageContent(index) {
    if (presentPage === null || pageSize === null) return;

    const previousPage = (presentPage - 1) * pageSize;
    const thisPage = presentPage * pageSize;

    return index + 1 <= thisPage && index + 1 > previousPage;
  }

  return [getPresentPageContent, presentPage, setPresentPage, pageSize, setPageSize];
};

// check if account has a feature authorization
export const useAuthorizedFeature = (feature) => {
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const { userRoles } = useSelector((state) => state.accountFeature);
  const { isLoadingGetProfile, getProfileMessage, getProfileFailed } = useSelector(
    (state) => state.profile,
  );

  useEffect(() => {
    if (isLoadingGetProfile) {
      setIsLoading(true);
    }

    if (getProfileMessage && !isLoadingGetProfile) {
      setIsLoading(false);
    }

    if (getProfileFailed && !isLoadingGetProfile) {
      setIsLoading(false);
    }
  }, [getProfileMessage, isLoadingGetProfile, getProfileFailed]);

  const unAuthorizedDisplay = !isLoading && (
    <Center m="30px 0px" h="100%">
      <Heading size="lg" m="0px 10px" textAlign="center">
        <Trans i18nKey="common.roleFailure">
          您尚未有權限可以使用此功能，詳細的使用權限請見
          <Link to={{ pathname: '/profile/role', hash: 'pricingList' }}>方案</Link>
        </Trans>
      </Heading>
    </Center>
  );

  useEffect(() => {
    // TODO: 應該改成 some function
    if (userRoles && userRoles?.includes(feature)) {
      setIsAuthorized(true);
    }

    if (userRoles && !userRoles?.includes(feature)) {
      setIsAuthorized(false);
    }
  }, [userRoles, feature]);

  return [isAuthorized, unAuthorizedDisplay];
};
